import React, { useContext } from 'react';
import styled from 'styled-components';
// import { PillGroup, SingleSelect } from '@ikea-ux/pill-button';
import '@ingka/pill/dist/style.css';
import "@ingka/focus/dist/style.css";
import Pill from "@ingka/pill";
import DataContext from '../DataContext/DataContext';
import './MenuCategoryList.css';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 16px;
`;

const MenuCategoryList = ({ selectedCategoryName, onChange = () => {} }) => {
  const { config, language } = useContext(DataContext);
  const categories = config.coworkerCategories || [];

  const pillClicked=(nameIdentifier)=> {
    // console.log("24", nameIdentifier)
    const clickedCategoryName = nameIdentifier;
    onChange(
      selectedCategoryName === clickedCategoryName ? null : nameIdentifier
    );
  }

  return (
    <Container>
       {categories.map(({ nameIdentifier, info }) => {
          if (nameIdentifier === 'all') {
            return null;
          }
          const { text } = info[language];
          return (
          <Pill className="pillCustomCSS"
          id={nameIdentifier}
          key={nameIdentifier}
          label={text}
          onClick={e=>pillClicked(nameIdentifier)}
          selected={nameIdentifier === selectedCategoryName}
         />
          )
        })}
      

      {/* <PillGroup onClick={pillClicked}>
        {categories.map(({ nameIdentifier, info }) => {
          if (nameIdentifier === 'all') {
            return null;
          }
          const { text } = info[language];
          return (
            <SingleSelect
              group="category"
              id={nameIdentifier}
              checked={nameIdentifier === selectedCategoryName}
              text={text}
              key={nameIdentifier}
            />
          );
        })}
      </PillGroup> */}
    </Container>
  );
};

export default MenuCategoryList;
